import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button"

import Logo from "../assets/media/logo-beauty-lounge.png";

import AuthService from "../services/auth.service";

import { withRouter } from '../common/with-router';

const required = value => {
    if (!value) {
      return (
        <span className="text-red-500 hidden" role="alert">
          Dieses Feld wird benötigt.
        </span>
      );
    }
};

class Login extends Component {
    constructor(props) {
      super(props);
      this.handleLogin = this.handleLogin.bind(this);
      this.onChangeUsername = this.onChangeUsername.bind(this);
      this.onChangePassword = this.onChangePassword.bind(this);
  
      this.state = {
        username: "",
        usernameValid: true,
        password: "",
        passwordValid: true,
        loading: false,
        message: "",
      };
    }
  
    onChangeUsername(e) {
      this.setState({
        username: e.target.value
      });
    }
  
    onChangePassword(e) {
      this.setState({
        password: e.target.value
      });
    }
  
    handleLogin(e) {
      e.preventDefault();
  
      this.setState({
        message: "",
        loading: true
      });

      if (this.state.username.length > 0) {
        this.setState({usernameValid: true})
      } else {
        this.setState({usernameValid: false})
      }

      if (this.state.password.length > 0) {
        this.setState({passwordValid: true})
      } else {
        this.setState({passwordValid: false})
      }
  
      this.form.validateAll();
  
      if (this.checkBtn.context._errors.length === 0) {
        AuthService.login(this.state.username, this.state.password).then(
          () => {
            this.props.router.navigate("/dashboard");
            window.location.reload();
          },
          error => {
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
  
            this.setState({
              loading: false,
              message: resMessage
            });
          }
        );
      } else {
        this.setState({
          loading: false
        });
      }
    }
  
    render() {
      return (
        <div className='flex flex-col min-h-screen lg:w-[80vw] max-w-5xl mx-auto'>
            <div className="login-box mt-auto rounded flex flex-col lg:flex-row max-w-sm md:max-w-none min-h-[450px] lg:h-2/3 shadow overflow-hidden">
                <div className='flex gradient-red justify-center p-10 lg:px-16 lg:w-[50%] lg:max-h-none'>
                    <img className='self-center p-50 h-[120px] lg:h-[180px]' src={Logo} />
                </div>
                <div className='flex flex-col bg-white p-10 lg:justify-between lg:w-[50%]'>
                    <div>
                        <h1 className='text-2xl font-bold'>BeautyLounge Lauda</h1>
                        <h2 className='text-lg text-gray-400'>Kundenverwaltung</h2>
                    </div>

                    <Form
                        className='flex flex-col justify-center h-full mt-5'
                        onSubmit={this.handleLogin}
                        ref={c => {
                        this.form = c;
                        }}
                    >

                        <Input
                            type="text"
                            className={"textbox mt-4 " + (this.state.usernameValid ? "" : "bg-red-200")}
                            name="username"
                            placeholder="Benutzername"
                            value={this.state.username}
                            onChange={this.onChangeUsername}
                            validations={[required]}
                        />

                        <Input
                            type="password"
                            className="textbox mt-4 mb-auto"
                            name="password"
                            placeholder="Passwort"
                            value={this.state.password}
                            onChange={this.onChangePassword}
                            validations={[required]}
                        />
                        
                        <span className="text-red-500 mt-5 h-5" role="alert">
                            {this.state.message ? 
                                this.state.message : ""
                            }
                        </span>

                        <div className='flex w-full mt-16 justify-between '>
                            <button className="base-button">Login</button>
                            <div className={"my-auto " + (this.state.loading ? "" : "hidden")} role="status">
                                <svg aria-hidden="true" className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-red-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                        <CheckButton
                            style={{ display: "none" }}
                            ref={c => {
                                this.checkBtn = c;
                            }}
                        />
                    </Form>
                </div>
            </div>
            <div className='flex flex-col lg:flex-row text-center justify-center mt-5 mb-auto gap-2'>
                <a>Passwort vergessen</a>
                <a>Datenschutzerklärung</a>
                <a>Impressum</a>
                <a>Website</a>
            </div>
            <span className='relative text-xs text-center text-gray-400 bottom-0 left-0 p-4'>VERSION: 4.23 (402399)</span>
        </div>
      );
    }
  }
  
  export default withRouter(Login);
